/* eslint-disable max-len */
export const commonMessages = {
    'Common.account': 'Account',
    'Common.account_manager': 'Account Manager',
    'Common.accounts': 'Accounts',
    'Common.accountsNotFound': 'No accounts found.',
    'Common.accountStatus': 'Account Status',
    'Common.accountsWithCount_one': 'Account',
    'Common.accountsWithCount_other': 'Accounts',
    'Common.action': 'Action',
    'Common.actionFilter': 'Action Filter',
    'Common.actions': 'Actions',
    'Common.active': 'Active',
    'Common.active_alerts': 'Active Alerts',
    'Common.active_user_count': 'Active Users Count',
    'Common.active_users': 'Active Users',
    'Common.activeUserCount': 'Active User Count',
    'Common.activity': 'Activity',
    'Common.activity_blocked': 'Tenant disabled/activity blocked',
    'Common.add': 'Add',
    'Common.add_client': 'Add Client',
    'Common.add_new_permission': 'Add New Permission',
    'Common.add_new_user': 'Add New User',
    'Common.added': 'Added',
    'Common.additionalLicenses': '+{{count}} licenses',
    'Common.address': 'Address',
    'Common.addToPanel': 'Add to panel',
    'Common.admin': 'Admin',
    'Common.admin_email': 'Admin Email',
    'Common.admin_hub': 'Admin Hub',
    'Common.admin_user': 'Admin User',
    'Common.administrator': 'Administrator',
    'Common.admins': 'Admins',
    'Common.alert': 'Alert',
    'Common.alerting': 'Alerting',
    'Common.alerts': 'Alerts',
    'Common.aliases': 'Aliases',
    'Common.all': 'All',
    'Common.all_accounts': 'All Accounts',
    'Common.all_applications': 'All Applications',
    'Common.all_categories': 'All Categories',
    'Common.all_clients': 'All Clients',
    'Common.all_devices': 'All Devices',
    'Common.all_groups': 'All Groups',
    'Common.all_time': 'All time',
    'Common.all_users': 'All Users',
    'Common.allSubCategories': 'All Subcategories',
    'Common.anm': 'ANM',
    'Common.api_key': 'API Key',
    'Common.api_secret': 'API Secret',
    'Common.apiPrivateKey': 'API Private Key',
    'Common.apiPublicKey': 'API Public Key',
    'Common.app': 'App',
    'Common.app_and_description': 'Application & Description',
    'Common.app_name': 'Application Name',
    'Common.application': 'Application',
    'Common.application_id': 'Application ID',
    'Common.application_library': 'Application Library',
    'Common.application_platforms': 'Application platforms',
    'Common.application_settings': 'Application Settings',
    'Common.application_stack': 'Application Stack',
    'Common.application_tag': 'Application Tag',
    'Common.applicationAdmin': 'Application Admin',
    'Common.applicationBaseName': 'Application Base Name',
    'Common.applicationCategory': 'Application Category',
    'Common.applicationDetails': 'Application Details',
    'Common.applicationIdentifiers': 'Application Identifiers',
    'Common.applicationRankingLast90Days': 'Application Ranking (Last 90 Days)',
    'Common.applicationRisk': 'Application Risk',
    'Common.applications': 'Applications',
    'Common.applicationState': 'Application State',
    'Common.applicationStates': 'Application States',
    'Common.applicationSubcategory': 'Application Sub-Category',
    'Common.applicationUniqueUsers': 'Application Unique Users',
    'Common.applicationWithCount_one': 'Application',
    'Common.applicationWithCount_other': 'Applications',
    'Common.appManagement': 'App Management',
    'Common.approve': 'Approve',
    'Common.approved': 'Approved',
    'Common.apps': 'Apps',
    'Common.appsAccessed': 'Accessed Applications',
    'Common.appStatusPage': 'Status Page',
    'Common.assign': 'Assign',
    'Common.autorefresh': 'Auto-refresh',
    'Common.auvik_logo': 'Auvik Logo',
    'Common.back': 'Back',
    'Common.backToPage': 'Back to {{name}}',
    'Common.backToPreviousPage': 'Back to previous page',
    'Common.beginner': 'Beginner',
    'Common.beta': 'Beta',
    'Common.billing_contact': 'Billing Contact',
    'Common.billing_details': 'Billing Details',
    'Common.blocked': 'Blocked',
    'Common.brand_name': 'Auvik SaaS Management',
    'Common.branding': 'Branding',
    'Common.brandingCustom': 'Use custom branding',
    'Common.breakdown': 'Breakdown',
    'Common.browser': 'Browser',
    'Common.browser_aliases': 'Browser Aliases',
    'Common.browser_history': 'Browser History',
    'Common.browser_login': 'Browser Login',
    'Common.browser_profiles': 'Browser Profiles',
    'Common.browsers': 'Browsers',
    'Common.bulk_edit': 'Bulk Edit',
    'Common.bulk_editor': 'Application Bulk Editor',
    'Common.bulkEditWithCount_one': 'Classify {{name}}',
    'Common.bulkEditWithCount_other': 'Bulk Classify {{count}} Applications',
    'Common.business_owner': 'Business Owner',
    'Common.business_purpose': 'Business Purpose',
    'Common.business_purpose_not_defined': 'No business purpose defined.',
    'Common.businessOwnerFilter': 'Business Owner Filter',
    'Common.cancel': 'Cancel',
    'Common.categories': 'Categories',
    'Common.category': 'Category',
    'Common.categoryNotFound': 'Category not found',
    'Common.cbr': 'Customer Business Review',
    'Common.checked': 'Checked',
    'Common.choose_a_client': 'Choose a Client',
    'Common.chooseSite': 'Choose a Site',
    'Common.classification': 'Classification',
    'Common.classificationFilter': 'Classification filter',
    'Common.classified': 'Classified',
    'Common.classify': 'Classify',
    'Common.classify_app': 'Classify Application',
    'Common.clear': 'Clear',
    'Common.click': 'Click',
    'Common.click_to_copy': 'Click To Copy',
    'Common.client': 'Client',
    'Common.client_count': 'Client Count',
    'Common.client_default': 'Client Default',
    'Common.client_level_permissions': 'Client Level Permissions',
    'Common.client_name': 'Client Name',
    'Common.client_note': 'Client Note',
    'Common.client_stages_breakdown': 'Client Deployment Stage Breakdown',
    'Common.client_stages_overview_breakdown':
        'Client Deployment Stage Overview Breakdown',
    'Common.clients': 'Clients',
    'Common.clients_impacted': 'Clients Impacted',
    'Common.clientsWithCount_one': 'Client',
    'Common.clientsWithCount_other': 'Clients',
    'Common.close': 'Close',
    'Common.cloud_app': 'Cloud App',
    'Common.cloud_logins': 'Cloud Logins',
    'Common.cloud_users': 'Cloud Users',
    'Common.cloudActivity': 'Cloud Activity',
    'Common.cloudActivityFound': 'Cloud Activity Found',
    'Common.cloudLogin': 'Cloud Login',
    'Common.cloudLoginData': 'App found via Browser Extensions with Form Login',
    'Common.cloudLoginFound': 'Cloud Login Found',
    'Common.color': 'Color',
    'Common.coming_soon': 'Coming Soon',
    'Common.community': 'Community',
    'Common.community_note': 'Community Note',
    'Common.company_domain': 'Company Domain',
    'Common.company_logins': 'Company Domain Logins',
    'Common.company_name': 'Company Name',
    'Common.company_related': 'Company-Related',
    'Common.complete': 'Complete',
    'Common.completed': 'Completed',
    'Common.computer': 'Computer',
    'Common.conditions': 'Conditions',
    'Common.configuration': 'Configuration',
    'Common.configure': 'Configure',
    'Common.confirm': 'Confirm',
    'Common.connect': 'Connect',
    'Common.continue': 'Continue',
    'Common.contract_configured': 'Contract Configured',
    'Common.contract_date': 'Contract Date',
    'Common.contract_hasBeenConfigured': 'Contract has been configured.',
    'Common.contract_hasNotBeenConfigured': 'Contract has not been configured.',
    'Common.contract_management': 'Contracts',
    'Common.contract_set': 'Contract',
    'Common.contractManagement': 'Contract Management',
    'Common.copied': 'Copied!',
    'Common.copy': 'Copy',
    'Common.copyright':
        '© Copyright 2013-2023 Auvik Networks Inc. All rights reserved.',
    'Common.cost': 'Cost',
    'Common.count': 'Count',
    'Common.create': 'Create',
    'Common.created': 'Created: {{date}}',
    'Common.created_by': 'Created By',
    'Common.created_for': 'Created For',
    'Common.createdOn': 'Created On',
    'Common.credential_exposure': 'Credential Exposure',
    'Common.critical': 'Critical',
    'Common.csv_upload': 'CSV Upload',
    'Common.currently_used': 'Currently Used',
    'Common.dashboard': 'Dashboard',
    'Common.data': 'Data',
    'Common.date': 'Date',
    'Common.dateAdded': 'Date Added',
    'Common.dateCreated': 'Date Created',
    'Common.dateDiscovered': 'Date Discovered',
    'Common.dateDiscoveredFilter': 'Date Discovered Filter',
    'Common.day': 'Day',
    'Common.days': 'days',
    'Common.days_fri': 'Fri',
    'Common.days_mon': 'Mon',
    'Common.days_sat': 'Sat',
    'Common.days_sun': 'Sun',
    'Common.days_thu': 'Thu',
    'Common.days_tue': 'Tue',
    'Common.days_wed': 'Wed',
    'Common.decommissioned': 'Decommissioned',
    'Common.decommissioning': 'Decommissioning',
    'Common.default': 'Default',
    'Common.default_confirm_text': 'This cannot be reversed.',
    'Common.default_new_permission': 'Default Permission For New Users',
    'Common.default_permission': 'Default Permission',
    'Common.delete': 'Delete',
    'Common.delta': 'Delta',
    'Common.deny': 'Deny',
    'Common.deploy': 'Deploy',
    'Common.deployment': 'Deployment',
    'Common.deployment_overview': 'Deployment Overview',
    'Common.deployment_scripts': 'Deployment Scripts',
    'Common.deployment_stage': 'Deployment Stage',
    'Common.description': 'Description',
    'Common.desktop_app': 'Desktop App',
    'Common.desktop_users': 'Desktop Users',
    'Common.desktopActivity': 'Desktop Activity',
    'Common.desktopActivityFound': 'Desktop Activity Found',
    'Common.desktopData': 'App found via Desktop Agent',
    'Common.destinations': 'Destinations',
    'Common.details': 'Details',
    'Common.detected': 'Detected',
    'Common.detected_users': 'Detected Users',
    'Common.device': 'Device',
    'Common.device_count': 'Device Count',
    'Common.device_hostname': 'Hostname',
    'Common.devices': 'Devices',
    'Common.devices_without_sso': 'Devices Without SSO',
    'Common.devicesWithCount_one': 'Device',
    'Common.devicesWithCount_other': 'Devices',
    'Common.disable': 'Disable',
    'Common.disabled': 'Disabled',
    'Common.disabledUserWithLicense_one': 'Disabled User With License',
    'Common.disabledUserWithLicense_other': 'Disabled Users With License',
    'Common.disableUser': 'Disable User',
    'Common.disconnect': 'Disconnect',
    'Common.disconnectConfirmation': 'Confirm Disconnection',
    'Common.discovered': 'Discovered',
    'Common.discovered_users': 'Discovered Users',
    'Common.documentation': 'Documentation',
    'Common.domain': 'Domain',
    'Common.domain_configuration': 'Domain Configuration',
    'Common.domain_managed': 'Domain Managed',
    'Common.domainAuth': 'Domain Auth',
    'Common.done': 'Done',
    'Common.dormant': 'Dormant',
    'Common.dormantAccount': 'Dormant Account',
    'Common.download': 'Download',
    'Common.download_script': 'Download Script',
    'Common.downloadActivity': 'Download Activity',
    'Common.downloadActivityData':
        'App found via Browser Extensions with Download Activity',
    'Common.downloadActivityFound': 'Download Activity Found',
    'Common.downloadInstaller': 'Download Installer',
    'Common.during': 'During',
    'Common.edit': 'Edit',
    'Common.edit_user': 'Edit User',
    'Common.editing_user': 'Editing User',
    'Common.email': 'Email',
    'Common.email_settings': 'Email Settings',
    'Common.email_subscribed': 'Receive Emails from Auvik SaaS Management',
    'Common.email_subscriptions': 'Email Subscriptions',
    'Common.enable': 'Enable',
    'Common.enabled': 'Enabled',
    'Common.enableUser': 'Enable User',
    'Common.end_date': 'End Date',
    'Common.endpoint': 'Endpoint',
    'Common.enterURL': 'Enter URL',
    'Common.entries': 'Entries',
    'Common.entry': 'Entry',
    'Common.error': 'An internal error has occurred.',
    'Common.evaluating': 'Evaluating',
    'Common.event': 'Event',
    'Common.exclude_cloud_applications': 'Exclude Cloud Applications',
    'Common.exclude_desktop_applications': 'Exclude Desktop Applications',
    'Common.exclude_links': 'Exclude Application Addition Logs',
    'Common.exclude_managed_applications': 'Exclude Managed Applications',
    'Common.exclude_personal_applications': 'Exclude Personal Applications',
    'Common.exclude_unapproved_applications':
        'Exclude Unnapproved Applications',
    'Common.exclude_unmanaged_applications': 'Exclude Unmanaged Applications',
    'Common.excluded': 'Excluded',
    'Common.excludeGroup': 'Exclude Group/OU',
    'Common.existing_user': 'Existing User',
    'Common.expert': 'Expert',
    'Common.expertise': 'Expertise',
    'Common.experts': 'Experts',
    'Common.export': 'Export',
    'Common.export_all': 'Export All',
    'Common.exportOffboardReport': 'Export Offboard Report',
    'Common.exportOffboardReport_description':
        'Discover which applications are associated with the user to prepare for offboarding.',
    'Common.extensionData':
        'App found via Browser Extensions with Web Activity',
    'Common.field': 'Field',
    'Common.file': 'File',
    'Common.file_description': 'File Description',
    'Common.filtered_results': 'Results are filtered',
    'Common.first': 'First',
    'Common.first_name': 'First Name',
    'Common.flags': 'Flags',
    'Common.form_login': 'Form Login',
    'Common.from': 'From',
    'Common.global_administration': 'Global Administration',
    'Common.globalAdmin': 'Global Admin',
    'Common.go': 'Go',
    'Common.google': 'Google',
    'Common.google_login': 'GWS Login',
    'Common.google_logins': 'GWS Logins',
    'Common.google_sso': 'Google SSO',
    'Common.google_workspace': 'Google Workspace',
    'Common.googleLoginData': 'App found via GWS Login',
    'Common.googleLoginFound': 'Google Login Found',
    'Common.grab_time': 'Grab a Time',
    'Common.greetingAfternoon': 'Good Afternoon!',
    'Common.greetingAfternoonWithName': 'Good Afternoon, {{name}}!',
    'Common.greetingEvening': 'Good Evening!',
    'Common.greetingEveningWithName': 'Good Evening, {{name}}!',
    'Common.greetingMorning': 'Good Morning!',
    'Common.greetingMorningWithName': 'Good Morning, {{name}}!',
    'Common.group': 'Group',
    'Common.group_policy': 'Group Policy',
    'Common.groupDescription': 'Group Description',
    'Common.groups': 'Groups',
    'Common.gwsSSOFound': 'GWS SSO Found',
    'Common.health_score': 'SaaS Health Score',
    'Common.hide_removed_tenants': 'Hide Removed Tenants',
    'Common.high': 'High',
    'Common.highUsage': 'High Usage',
    'Common.hub': 'Hub',
    'Common.hub_settings': 'Hub Settings',
    'Common.id': 'ID',
    'Common.identityIntegrationStatus': 'Identity Integration Status',
    'Common.identityManagementIntegrations':
        'Connect Microsoft Entra ID, Google Workspace, or Okta to enrich your SaaS insights. With Entra and Google, automatically import users, groups, and application data for deeper visibility into departments and access patterns. With Okta, gain powerful application-level insights to strengthen your identity and SaaS management.',
    'Common.image': 'Image',
    'Common.impact': 'Impact',
    'Common.implementing': 'Implementing',
    'Common.import': 'Import',
    'Common.important': 'Important',
    'Common.important_note': 'Important Note',
    'Common.imported': 'Imported',
    'Common.importing_user': 'Importing user',
    'Common.importReport': 'Import for Reporting',
    'Common.importUser': 'Import User',
    'Common.in_beta': 'In Beta',
    'Common.inactive': 'Inactive',
    'Common.incident_flags': 'Incident Flags',
    'Common.incidentFlagsFilter': 'Incident Flags Filter',
    'Common.include_expired_disabled_users': 'Include Expired/Disabled Users',
    'Common.include_only_cloud_applications': 'Include Cloud Applications',
    'Common.include_only_desktop_applications': 'Include Desktop Applications',
    'Common.include_smart_score_filtering': 'Smart Score Filtering',
    'Common.includeGroup': 'Include Group/OU',
    'Common.individual': 'Individual',
    'Common.insights': 'Insights',
    'Common.integration_details': 'Integration Details',
    'Common.integrations': 'Integrations',
    'Common.intermediate': 'Skilled',
    'Common.internal_name': 'Internal Name',
    'Common.internalTenant': 'Internal Deployment',
    'Common.invitation_status': 'Invitation Status',
    'Common.invite_users': 'Invite Users',
    'Common.ip': 'IP',
    'Common.job_title': 'Title',
    'Common.just_updated': 'Just Updated',
    'Common.label': 'Label',
    'Common.last_check_in': 'Last Check-In',
    'Common.last_managed': 'Last Check-In',
    'Common.last_modified': 'Last Modified',
    'Common.last_name': 'Last Name',
    'Common.last_used': 'Last Used',
    'Common.last_user_added': 'Last User Added <Date />',
    'Common.lastCheckIn': 'Last Check-In',
    'Common.lastIncidentUpdate': 'Last Incident Update',
    'Common.lastLogin': 'Last login was more than {{days}} days ago.',
    'Common.lastLoginTime': 'Last Login Time',
    'Common.lastUpdated': 'Last Updated',
    'Common.lastUpdateValue': 'Last update: {{value}}',
    'Common.learning_mode': 'Learning Mode',
    'Common.license_breakdown_usage_last_week': 'License Usage Last Week',
    'Common.license_count': 'License Count',
    'Common.license_overview_usage_last_week': 'License Usage Last Week',
    'Common.license_state': 'License Usage Lifecycle Stage',
    'Common.licenseData': 'License Data',
    'Common.licenses': 'Licenses',
    'Common.licensesUnderutilized': 'Underutilized Licenses',
    'Common.licensesUndetected': 'Undetected Licenses',
    'Common.licenseType': 'License Type',
    'Common.licenseTypesWithCount_one': 'License Type',
    'Common.licenseTypesWithCount_other': 'License Types',
    'Common.lifecycle': 'Lifecycle',
    'Common.lifecycleFilter': 'Lifecycle Stage Filter',
    'Common.lifecycleStage': 'Lifecycle Stage',
    'Common.link': 'Link',
    'Common.loading': 'Loading',
    'Common.locked_dashboard': 'Locked Dashboard',
    'Common.log_in': 'Log in',
    'Common.login': 'Login',
    'Common.login_google': 'Sign in with Google',
    'Common.login_microsoft': 'Sign in with Microsoft',
    'Common.logins_detected': 'Logins Detected',
    'Common.loginUsername': 'Login Username',
    'Common.logout': 'Logout',
    'Common.logs': 'Logs',
    'Common.low': 'Low',
    'Common.lowUsage': 'Low Usage',
    'Common.mac.logo': 'Mac logo',
    'Common.macAddress': 'MAC Address',
    'Common.macOS': 'Mac OS',
    'Common.macos.logo': 'Mac OS logo',
    'Common.main_settings': 'Settings',
    'Common.manage': 'Manage',
    'Common.manage_applications': 'Manage Applications',
    'Common.manage_clients': 'Manage Clients',
    'Common.manage_permission_groups': 'Manage Permission Groups',
    'Common.manage_users': 'Manage Users',
    'Common.managed': 'Managed',
    'Common.managed_applications': 'Managed Applications',
    'Common.managed_by_3rd_party': 'Managed By 3rd Party',
    'Common.managed_by_partner': 'Managed By Partner',
    'Common.managedApplication': 'Managed Application',
    'Common.managedFilter': 'Managed Filter',
    'Common.management_stage': 'Management Stage',
    'Common.managementState': 'Management State',
    'Common.manager': 'Manager',
    'Common.managing': 'Managing',
    'Common.medium': 'Medium',
    'Common.mediumUsage': 'Medium Usage',
    'Common.metadata': 'Metadata',
    'Common.mfa': 'MFA',
    'Common.microsoft': 'Microsoft',
    'Common.microsoft_sso': 'Microsoft SSO',
    'Common.microsoftEntraID': 'Microsoft Entra ID',
    'Common.microsoftEntraID.login': 'Microsoft Entra ID Login',
    'Common.microsoftEntraID.loginData':
        'App found via Microsoft Entra ID Login',
    'Common.microsoftEntraID.loginFound': 'Microsoft Entra ID Login Found',
    'Common.microsoftEntraID.logins': 'Microsoft Entra ID Logins',
    'Common.microsoftEntraID.sync': 'Microsoft Entra ID Sync',
    'Common.microsoftSSOFound': 'Microsoft SSO found',
    'Common.minimumUsage': 'Minimum Usage',
    'Common.monitored': 'Monitored',
    'Common.month': 'Month',
    'Common.monthly_contracts': 'Month To Month Contracts',
    'Common.mrr': 'Monthly Recurring Costs',
    'Common.multiple_applications': 'Multiple Applications',
    'Common.n/a': 'N/A',
    'Common.name': 'Name',
    'Common.never': 'Never',
    'Common.new': 'New',
    'Common.next': 'Next',
    'Common.no': 'No',
    'Common.no_client_id': 'No Client ID',
    'Common.no_clients_impacted': 'No Clients Impacted',
    'Common.no_management_stage_selected': 'No Management Stage Selected',
    'Common.no_purpose_set': 'No Purpose Set',
    'Common.no_risk_assigned': 'No Risk Assigned',
    'Common.no_tags_assigned': 'No Tags Assigned',
    'Common.no_thanks': 'No Thanks',
    'Common.no_usage': 'No Usage',
    'Common.no_user_selected': 'No user selected',
    'Common.no_user_selected.error': 'No user selected.',
    'Common.no_users': 'No Users',
    'Common.noAppFound.description':
        'This can happen if an app was removed or if you selected an invalid link. If this issue continues, please contact support.',
    'Common.noAppFound.title': 'App not found',
    'Common.noBusinessOwnerRequired': 'No Business Owner Required',
    'Common.noData': 'No data available.',
    'Common.noData.selectRange':
        'No data available. Select an alternative time range.',
    'Common.noData.short': 'No data',
    'Common.noEmailFound': 'No email found',
    'Common.noImage': 'No image',
    'Common.noManagerFound': 'No manager found',
    'Common.none': 'None',
    'Common.noPublisher': 'No publisher',
    'Common.normal': 'Normal',
    'Common.not_assigned': 'Not Assigned',
    'Common.not_configured': 'Not configured',
    'Common.not_detected': 'Not Detected',
    'Common.not_found': 'Not Found',
    'Common.not_required': 'Not Required',
    'Common.noTagsSelected': 'No tags selected',
    'Common.notConfigured': 'Not configured',
    'Common.note': 'Note',
    'Common.note/recommendation': 'Note / Recommendation',
    'Common.notelio': 'Notelio',
    'Common.notes': 'Notes',
    'Common.notes_and_recommendations': 'Notes & Recommendations',
    'Common.noTitleFound': 'No title found',
    'Common.notMonitored': 'Not Monitored',
    'Common.notSupported': 'Not Supported',
    'Common.nrc': 'Non-Recurring Costs',
    'Common.num_users_impacted': '# Users Impacted',
    'Common.offboard': 'Offboard',
    'Common.ok': 'Ok',
    'Common.okta': 'Okta',
    'Common.oktaLogin': 'Okta Login',
    'Common.oktaLoginData': 'App found via Okta Login',
    'Common.oktaLoginFound': 'Okta Login Found',
    'Common.onboard': 'Onboard',
    'Common.open_support_ticket': 'Open A Support Ticket',
    'Common.or': 'or',
    'Common.org_preferences': 'Org Preferences',
    'Common.org_unit': 'Org Unit',
    'Common.org_unit_bold':
        'Org Unit: <span style="font-weight:600;">{{orgUnit}}</span>',
    'Common.organization': 'Organization',
    'Common.organization_level_permissions': 'Organization Level Permissions',
    'Common.organizations': 'Organizations',
    'Common.os': 'Operating System',
    'Common.other': 'Other',
    'Common.overlap_apps': 'Overlap Applications',
    'Common.overview': 'Overview',
    'Common.owner': 'Owner',
    'Common.owners': 'Owners',
    'Common.partner': 'Partner',
    'Common.partner_application_settings': 'Applications',
    'Common.partner_dashboard': 'Partner Dashboard',
    'Common.partner_hub': 'Partner Hub',
    'Common.partner_integrations': 'Partner Integrations',
    'Common.partner_name': 'Partner Name',
    'Common.partner_note': 'Partner Note',
    'Common.partner_settings': 'Personal Partner Settings',
    'Common.partner_token': 'Partner Token',
    'Common.partner_user': 'Partner User',
    'Common.partnerdeployment': 'Partner Deployment',
    'Common.pause': 'Pause',
    'Common.percent': 'Percent',
    'Common.percentage': 'Percentage',
    'Common.period': 'Period',
    'Common.permission': 'Permission',
    'Common.permission_added': 'Permission Added',
    'Common.permission_enabled': 'Permission Enabled',
    'Common.permission_updated': 'Permission Updated',
    'Common.permissions': 'Permissions',
    'Common.personal': 'Personal',
    'Common.personalAccount': 'Personal Account',
    'Common.personalOther': 'Personal / Other',
    'Common.powershell': 'PowerShell',
    'Common.prepared_by': 'Prepared By:',
    'Common.prepared_for': 'Prepared For:',
    'Common.prepared_on': 'Prepared on {{date}}',
    'Common.preview': 'Preview',
    'Common.previous': 'Previous',
    'Common.print': 'Print',
    'Common.product_experts': 'Product Experts',
    'Common.product_name': 'Product Name',
    'Common.profile': 'Profile',
    'Common.publish': 'Publish',
    'Common.published_by': 'Published By',
    'Common.publisher': 'Publisher',
    'Common.publisherId': 'Publisher ID',
    'Common.purpose': 'Purpose',
    'Common.quarter': 'Quarter',
    'Common.quick': 'Quick',
    'Common.quick_links': 'Quick Links',
    'Common.quick_start_guide': 'Quick Start Guide',
    'Common.quickScanLoginFound': 'App found via Browser History',
    'Common.rank': 'Rank',
    'Common.re-authenticate': 'Re-authenticate',
    'Common.recent_usage': 'Recent Usage',
    'Common.recently_added_clients': 'Recently Added Clients',
    'Common.reconnect': 'Reconnect',
    'Common.recover': 'Recover',
    'Common.redirect.exportReports':
        'To export other types of reports, please go to the <Link>Reports Page.</Link>',
    'Common.refresh': 'Refresh',
    'Common.region': 'Region',
    'Common.related_app_usage': 'Related App Usage',
    'Common.related_app_users': 'Related App Users',
    'Common.remove': 'Remove',
    'Common.remove_from_panel': 'Remove from panel',
    'Common.removed': 'Removed',
    'Common.renewal_contracts': 'Renewal Contracts',
    'Common.report': 'Report',
    'Common.reports': 'Reports',
    'Common.reports_ran': 'Reports Ran',
    'Common.reset': 'Reset',
    'Common.resetToDefault': 'Reset to default',
    'Common.restore': 'Restore',
    'Common.review': 'Review',
    'Common.risk': 'Risk',
    'Common.riskFilter': 'Risk Filter',
    'Common.run': 'Run',
    'Common.run_reports': 'Run Reports',
    'Common.saasOps': 'SaaS Ops',
    'Common.safe': 'Safe',
    'Common.sales_hub': 'Sales Docs',
    'Common.sales_support': 'Sales & Support',
    'Common.save': 'Save',
    'Common.save_changes': 'Save Changes',
    'Common.save_settings': 'Save Settings',
    'Common.schema': 'Schema',
    'Common.score': 'Score',
    'Common.scripts': 'Scripts',
    'Common.search': 'Search',
    'Common.security_logs': 'Security Logs',
    'Common.seeAll': 'See All',
    'Common.select': 'Select',
    'Common.select.lifecycleStage': 'Select lifecycle stage',
    'Common.select_all': 'Select All',
    'Common.select_application': 'Select application',
    'Common.select_application(s)': 'Select application(s)',
    'Common.select_applications': 'Select applications',
    'Common.select_categories': 'Select categories',
    'Common.select_management_stage': 'Select management stage',
    'Common.select_tags': 'Select tags',
    'Common.selectAnOption': 'Select an option',
    'Common.selection': 'Selection',
    'Common.selectSubCategories': 'Select subcategories',
    'Common.send': 'Send',
    'Common.settings': 'Settings',
    'Common.setup': 'Setup',
    'Common.shared': 'Shared',
    'Common.shared_account': 'Shared Account',
    'Common.showDisabledExpiredUsers': 'Show Disabled/Expired Users',
    'Common.signin': 'Sign-in',
    'Common.site': 'Site',
    'Common.size': 'Size',
    'Common.slogan': 'Bring your cloud back down to earth.',
    'Common.sloganPart2':
        '<span style="font-weight:600;">Uncover</span>, <span style="font-weight:600;">manage</span>, and <span style="font-weight:600;">secure</span> your<br>clients’ SaaS ecosystems.',
    'Common.sloganSplit': 'Bring your cloud<br>back down to earth.',
    'Common.source': 'Source',
    'Common.sourceFilter': 'Source Filter',
    'Common.sources': 'Sources',
    'Common.sso': 'SSO',
    'Common.ssoCoverage': 'SSO Coverage',
    'Common.ssoCoverageFilter': 'SSO Coverage Filter',
    'Common.ssoCoverageWithDivider': 'SSO Coverage:',
    'Common.ssoEnabled': 'SSO Enabled',
    'Common.ssoFilter': 'SSO Filter',
    'Common.ssoSupport': 'SSO Coverage',
    'Common.start': 'Start',
    'Common.startDate': 'Start Date',
    'Common.state': 'State',
    'Common.status': 'Status',
    'Common.step': 'Step',
    'Common.sub_category': 'Sub-Category',
    'Common.subCategory': 'Subcategory',
    'Common.subject': 'Subject',
    'Common.subscriptions': 'Subscriptions',
    'Common.suggested_actions': 'Suggested Actions',
    'Common.suggested_steps': 'Suggested Steps',
    'Common.support_center': 'Support Center',
    'Common.system': 'System',
    'Common.tag': 'Tag',
    'Common.tags': 'Tags',
    'Common.tbd': 'To Be Determined',
    'Common.tbd_abbr': 'TBD',
    'Common.tbd_ranking':
        'Rank is determined by the amount of total usage of an app. Rank may not show for newly discovered apps or apps where usage cannot be tracked.',
    'Common.tcv': 'TCV',
    'Common.tcv_full': 'Total Contract Costs',
    'Common.team': 'Team',
    'Common.team_admins': 'Team Admins',
    'Common.tenant': 'Tenant',
    'Common.test': 'Test',
    'Common.theme': 'Theme',
    'Common.time.lessThan5min': '<5 min',
    'Common.time.lessThan15min': '<15 min',
    'Common.time.lessThan30min': '<30 min',
    'Common.time.lessThanOneHour': '<1 hr',
    'Common.time.numberOfHours_one': '{{hours}} hr',
    'Common.time.numberOfHours_other': '{{hours}} hrs',
    'Common.time_period': 'Period',
    'Common.timestamp': 'Timestamp',
    'Common.timestampUTC': 'Timestamp (UTC)',
    'Common.tips': 'Tips',
    'Common.title': 'Title',
    'Common.to': 'To',
    'Common.today': 'Today',
    'Common.top_client_applications_used_last_week':
        'Top Client Applications Used Last Week',
    'Common.total': 'Total',
    'Common.total_applications': 'Total Applications',
    'Common.total_apps': 'Total Apps',
    'Common.total_clients': 'Total Clients',
    'Common.total_contracts': 'Total Contracts',
    'Common.total_devices': 'Total Devices',
    'Common.total_usage': 'Total Usage',
    'Common.total_user_count': 'Total User Count',
    'Common.total_users': 'Total Users',
    'Common.totalAccounts': 'Total Accounts',
    'Common.totalDevicesNotUsing': 'Devices Not Utilizing Application',
    'Common.totalDevicesUsing': 'Devices Utilizing Application',
    'Common.totalLicenses': 'Total Licenses',
    'Common.trial': 'Get Started With Your Trial Today!',
    'Common.trial_details': 'Trial Details',
    'Common.trial_text': 'Trial',
    'Common.type': 'Type',
    'Common.unanalyzedApplications': 'Unanalyzed Applications',
    'Common.unapproved': 'Unapproved',
    'Common.unavailable': 'Unavailable',
    'Common.uncategorized': 'Uncategorized',
    'Common.unclassified': 'Unclassified',
    'Common.unclassified_applications': 'Unclassified Applications',
    'Common.unclassified_breakdown': 'Unclassified Breakdown',
    'Common.unclassifiedApplication': 'Unclassified Application',
    'Common.underutilized': 'Underutilized',
    'Common.undo': 'Undo',
    'Common.unique_client_applications': 'Unique Client Applications',
    'Common.unique_id': 'Unique ID',
    'Common.unique_users': 'Unique Users',
    'Common.unknown': 'Unknown',
    'Common.unmanaged': 'Unmanaged',
    'Common.unmanaged_applications': 'Unmanaged Applications',
    'Common.unmanagedApplication': 'Unmanaged Application',
    'Common.unselectAll': 'Unselect All',
    'Common.unselected': 'Unselected',
    'Common.unsubscribe': 'Unsubscribe',
    'Common.update': 'Update',
    'Common.updated': 'Successfully updated.',
    'Common.updateInProgress': 'Update in progress. Please check back soon.',
    'Common.upns': 'UPNs',
    'Common.url': 'URL',
    'Common.usage': 'Usage',
    'Common.usage_chart': 'Usage Chart',
    'Common.usage_last_20_weeks': 'Last 20 Weeks Usage',
    'Common.usage_last_week': 'Usage Last Week',
    'Common.usage_over_90': 'usage over last 90 days.',
    'Common.usageDelta': 'Usage Delta',
    'Common.usageLast90': 'Usage (Last 90 Days)',
    'Common.used': 'Used',
    'Common.user': 'User',
    'Common.user_count': 'User Count',
    'Common.user_details': 'User Details',
    'Common.userDateCreated': 'Date Created',
    'Common.userEmail': 'User Email',
    'Common.userEmailOrId': 'User Email or ID',
    'Common.userFirstName': 'User First Name',
    'Common.userId': 'User ID',
    'Common.userLastCheckIn': 'Last Check-In {{date}}',
    'Common.userLastName': 'User Last Name',
    'Common.userLastSignIn': 'Last Sign-In',
    'Common.username_detected': 'Username Detected',
    'Common.usernames': 'Usernames',
    'Common.users': 'Users',
    'Common.users_and_devices': 'Users & Devices',
    'Common.users_and_groups': 'Users & Groups',
    'Common.usersDelta': 'Users Delta',
    'Common.usersImpacted': 'Users Impacted',
    'Common.usersWithCount_one': 'User',
    'Common.usersWithCount_other': 'Users',
    'Common.using_application': 'Utilizing Application',
    'Common.utilities': 'Utilities',
    'Common.value': 'Value',
    'Common.vendor_incident': 'Vendor Incident',
    'Common.vendor_incidents': 'Vendor Incidents',
    'Common.verbiage_for_bulk_editor_before_link':
        'If you are looking to make many edits to multiple applications, it is recommended to do this in the ',
    'Common.version': 'Version',
    'Common.versionFilter': 'Version Filter',
    'Common.versions': 'Versions',
    'Common.view': 'View',
    'Common.view_client': 'View Client',
    'Common.view_impacted_users': 'View Impacted Users',
    'Common.views': 'Views',
    'Common.viewUsers': 'View users',
    'Common.waste': 'Waste',
    'Common.web_app': 'Web App',
    'Common.webhooks': 'Webhooks',
    'Common.website': 'Website',
    'Common.week': 'Week',
    'Common.weekOf': 'Week of',
    'Common.windows.logo': 'Windows logo',
    'Common.windowsOS': 'Windows OS',
    'Common.windowsOS.logo': 'Windows OS logo',
    'Common.work': 'Work',
    'Common.work_usage': 'Work Usage',
    'Common.work_usage_only': 'Work Usage Only',
    'Common.workUsagePercent': 'Work Usage %',
    'Common.yes': 'Yes',
    'Common.yesterday': 'Yesterday'
};
